import { Button, TableCell, TableRow, Typography } from '@mui/material';
import { SalaryCommissionRowDto } from '@sr/dto';
import { GridLayout, HeadCellsCollection } from 'shared/ui/grid-layout';
import { formatDateTime } from 'utils/date-format-helpers';
import { formatPersonPruning } from 'utils/person-format-helpers';
import PriceSpan from 'shared/ui/price-span';
import { useSalaryCommission } from './salary-entries.hook';
import { Link } from 'react-router-dom';
import { invoiceLinkManager } from 'utils/link-manager';

const columns: HeadCellsCollection = [
  { label: '№', align: 'left' },
  { label: 'Кто начислил', align: 'left' },
  { label: 'Дата начисления', align: 'left' },
  { label: 'Сумма начисления', align: 'right' },
  { label: 'Счет', align: 'left' },
  { label: 'Сумма счета', align: 'right' },
  { label: 'Прибыль счета', align: 'right' },
  { label: 'Ставка по счету', align: 'right' },
];

const CommissionRow = ({ row, index }: { row: SalaryCommissionRowDto; index: number }) => (
  <TableRow hover>
    <TableCell sx={{ color: 'text.secondary' }}>{index + 1}</TableCell>
    <TableCell>{formatPersonPruning(row.createdBy)}</TableCell>
    <TableCell sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>{formatDateTime(row.createdAt)}</TableCell>
    <TableCell align="right"><PriceSpan price={row.sum} color={row.sum >= 0 ? 'success.main' : 'error'} size="small" showZeroKop /></TableCell>
    <TableCell>
      {row.invoiceId && row.invoiceNumber
        ? (
          <Button component={Link} to={invoiceLinkManager.reportLink(row.invoiceId)} variant="outlined" size="small">
            {row.invoiceNumber}
          </Button>
        )
        : '—'}
    </TableCell>
    <TableCell align="right"><PriceSpan price={row.invoiceTotal} size="small" showZeroKop /></TableCell>
    <TableCell align="right"><PriceSpan price={row.invoiceProfit} size="small" showZeroKop /></TableCell>
    <TableCell align="right">{row.managerPercent}%</TableCell>
  </TableRow>
);

const CommissionTotal = (rows: SalaryCommissionRowDto[]) => {
  const totalAccrual = rows.reduce((acc, row) => acc + (row.sum || 0), 0);
  const totalInvoice = rows.reduce((acc, row) => acc + (row.invoiceTotal || 0), 0);
  const totalProfit = rows.reduce((acc, row) => acc + (row.invoiceProfit || 0), 0);

  return (
    <TableRow sx={{ '& td': { borderTop: 2, borderColor: 'divider', backgroundColor: 'action.hover' } }}>
      <TableCell>
        <Typography variant="subtitle1" fontWeight={600}>Итого:</Typography>
      </TableCell>
      <TableCell />
      <TableCell />
      <TableCell align="right"><PriceSpan price={totalAccrual} color={totalAccrual >= 0 ? 'success.main' : 'error'} size="regular" showZeroKop /></TableCell>
      <TableCell />
      <TableCell align="right"><PriceSpan price={totalInvoice} size="regular" showZeroKop /></TableCell>
      <TableCell align="right"><PriceSpan price={totalProfit} size="regular" showZeroKop /></TableCell>
      <TableCell />
    </TableRow>
  );
};

export const SalaryCommissionGrid = ({ year, month, userId }: { year: number; month: number; userId: number }) => {
  const { rows, isLoading, error } = useSalaryCommission(year, month, userId);

  return (
    <GridLayout
      columns={columns}
      items={rows}
      isLoading={isLoading}
      error={error}
      height="auto"
      footer={CommissionTotal}
      itemRender={(row, index) => <CommissionRow key={row.id} row={row} index={index} />}
      noItemsText="У выбранного пользователя нет процентов по счетам в выбранном периоде"
    />
  );
};
